<template>
    <v-container>
        <h1 class="display-1">Create Party</h1>

        <v-card class="mt-4">
            <v-card-text>
                <v-text-field v-model="form.name"
                              @keydown.enter="storeParty"
                              label="Name"/>
            </v-card-text>

            <v-divider/>

            <v-card-actions>
                <v-btn color="secondary"
                       text
                       @click="$router.push({name: 'campaign', params: {campaignId: $route.params.campaignId}})">
                    Cancel
                </v-btn>
                <v-btn text color="primary" @click="storeParty" :loading="loading">Create</v-btn>
            </v-card-actions>
        </v-card>
    </v-container>
</template>

<script>
  import PartyService from "../services/PartyService";

  export default {
    data: () => ({
      loading: false,
      form: {
        name: null,
        character_class_id: null
      }
    }),

    methods: {
      storeParty() {
        this.loading = true;
        this.form.campaign_id = this.$route.params.campaignId;

        PartyService.store(this.form)
          .then(() => {
            this.$router.push({name: 'campaign', params: {campaignId: this.$route.params.campaignId}});
          })
          .catch(err => {
            console.log(err);
            this.loading = false;
          });
      }
    }
  };
</script>
